import { axiosInstance } from '@/api/index';
import { IServerResponse } from '@/api/types';
import { AxiosResponse } from 'axios';
import { API_OFFERS_URL } from '@/configs/global';
import {
    IAffiliateCap,
    IGetAffiliateCapsParams,
    ISetAffiliateCapPayload,
} from '@/api/types/offer-access';

const AFFILIATE_CAPS_URL = `${API_OFFERS_URL}/employees/offer-access/affiliate-caps`;

/**
 *  Список индивидуальных лимитов партнёров по офферам
 */
export async function getAffiliateCaps(
    params?: IGetAffiliateCapsParams,
): Promise<IServerResponse<IAffiliateCap[]>> {
    return axiosInstance.request<IServerResponse<IAffiliateCap[]>>({
        method: 'GET',
        url: AFFILIATE_CAPS_URL,
        params,
    })
        .then((response: AxiosResponse<IServerResponse<IAffiliateCap[]>>) => response.data);
}

/**
 *  Установка / обновление индивидуального лимита партнёра по офферу
 */
export async function setAffiliateCap(
    data: ISetAffiliateCapPayload,
): Promise<void> {
    return axiosInstance.request<void>({
        method: 'POST',
        url: AFFILIATE_CAPS_URL,
        data,
    })
        .then((response: AxiosResponse<void>) => response.data);
}
